//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name:'PELD',
  data() {
    return {
      defaultJson:{
        "Growth Failure": "生长延迟",
        "Total Bilirubin": "总胆红素",
        "INR": "INR",
        "Albumin": "白蛋白",
        "Age < 1 year": "年龄 < 1 岁"
      },
      form:{
        inr:'',
        alb:'',
        bili:'',
        growth:'0',
        age:'0',
      },
      alb_n:'',
      bili_n:'',
      inr_n:'',
      hasScore:false,
      disabled:false,
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else { 
            if (form[key]=='---') {
              flag = false
            } else {  
              form[key] = Number(form[key])
            }
          }
        }
      }
      if (!flag) {
        self.hasScore = false
        self.alb_n ='--'
        return '--'
      } else {

        // alb < 1 ? 1 : alb
        self.alb_n = form.alb < 1 ? 1 : form.alb

        // bili < 1 ? 1 : bili
        self.bili_n = form.bili < 1 ? 1 : form.bili

        // inr < 1 ? 1 : inr
        self.inr_n = form.inr < 1 ? 1 : form.inr
        // alb_n ? bili_n ? inr_n ? round((4.8 * ln(bili_n)) + (18.57 * ln(inr_n)) - (6.87 * ln(alb_n)) + (4.36*age) + (6.67*growth))
        let result =  Math.round((4.8 * Math.log(self.bili_n)) + (18.57 * Math.log(self.inr_n)) - (6.87 * Math.log(self.alb_n)) + (4.36*form.age) + (6.67*form.growth))
        
        self.hasScore = true
        return String(result)
      }
    }
  },
  
  
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Pedi/PELD.vue